import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

const OPTION_TYPES = [
  { label: 'Traded Price', value: 'traded_price' },
  { label: 'Signal Price', value: 'signal_price' }
];

const propTypes = {
  optionType: PropTypes.string.isRequired,
  onOptionTypeChange: PropTypes.func.isRequired
};
const defaultProps = {};

const SlOrderBasedOnPriceSelector = ({
  optionType: propsOptionType, onOptionTypeChange
}) => {
  const [optionTypeBtnName] = useState(_.uniqueId('optionSlOrderBasedOnPrice-'));
  const optionTypeInputId = _.uniqueId('optionTypeSelector');
  const { errors, register } = useFormContext();
  const validatorConfig = { validate: (value) => (!value ? 'value required' : null) };
  const validatorProps = { ref: register(validatorConfig) };

  const optionTypeStyle = classNames(
    'option-type',
    'align-items-center',
    'gap-10',
    'mt-1',
    'd-flex',
    'selector-radio-btn'
  );
  const radioBtnStyle = classNames(
    'form-check-input',
    { 'is-invalid': !!errors[optionTypeBtnName] }
  );

  const renderRadioBtn = (optionType) => {
    return (
      <div className="form-check" key={optionType.value}>
        <input
          {...validatorProps}
          className={radioBtnStyle}
          type="radio"
          name={optionTypeBtnName}
          id={`${optionTypeInputId}-${optionType.value}`}
          value={optionType.value}
          tabIndex="-100"
          checked={optionType.value === propsOptionType}
          onChange={() => onOptionTypeChange(optionType.value)}
        />
        <label className="form-check-label" htmlFor={`${optionTypeInputId}-${optionType.value}`}>
          {_.startCase(optionType.label)}
        </label>
      </div>
    );
  };

  const optionTypeRadioBtns = _.map(OPTION_TYPES, renderRadioBtn);

  return (
    <div className={optionTypeStyle}>
      {optionTypeRadioBtns}
    </div>
  );
};

SlOrderBasedOnPriceSelector.propTypes = propTypes;
SlOrderBasedOnPriceSelector.defaultProps = defaultProps;

export default SlOrderBasedOnPriceSelector;
